
import { debounce as _debounce } from 'underscore';


export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,
            mobile : true,
            tablet : true,
            is_mobile : $('html').hasClass('mobile'),
            is_tablet : $('html').hasClass('touch'),
        	classes : [ '.widow' ],

        	/*
				
				https://blog.mailtrap.io/nbsp/
				All options for no breaking spaces

        	*/

        	// Safari
        	spacer : '&nbsp;'  //'<span class="spacer-widow"></span>' //'&#8202;' // it's narrow than '&nbsp;'
        };



        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'widows_and_orphans';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
		this.$win           =   $(window);


        // if ( $('html').hasClass( 'chrome' ) ){
        // 	this.options.spacer = '&thinsp;'
        // }

        if ( $('html').hasClass( 'firefox' ) ){
        	this.options.spacer = '&thinsp;'
        }

		this.init();
	
    }

    init(){
    	this.process();
    	this.debounceResize( true );
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => {
                this.onResize();
            }, 117 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){
    	this.reset();
    	this.process()
    }


    reset(){
		let i = this.options.classes.length, 
		$selector,
		$s;
		if ( i > 0 ){
			while ( i-- ){
				$selector = $( this.options.classes[i] );
				if ( $selector.length > 0 ){
		    		$selector.each(function(){
		    			$s = $(this);
		    			if ( $s.data( 'or-text' ) && $s.hasClass( 'widow-transform' ) ){
		    				$s.html( $s.data( 'or-text' ) );
		    				$s.removeClass( 'widow-transform' );
		    			}
	  				});
				}
			}
		}    	
    }

    process(){
		let i = this.options.classes.length, 
		$selector,
		$s, 
		string = '',
		spacer = this.options.spacer;

        if (!this.options.mobile && this.options.is_mobile) {
            //c('widowsAndOrphans: is_mobile, stopping');
            return;
        }
        if (!this.options.tablet && this.options.is_tablet) {
            //c('widowsAndOrphans: is_tablet, stopping');
            return;
        }

		if ( i > 0 ){
			while ( i-- ){
				$selector = $( this.options.classes[i] );
				if ( $selector.length > 0 ){
		    		$selector.each(function(){
		    			$s = $(this);

		    			string = $s.html().trim();

		    			if ( !$s.data( 'or-text' ) ){
		    				$s.data( 'or-text', string );
		    			}

		    			// if words > 3
		    			if ( string.split(' ').length <= 3 ){
		    				string = false;
		    			}

		    			// Are there other conditions to check for???
		    			if ( string ){
		    				
		    				//console.log( 'last char is = ' + string.charAt(string.length-1) );

		    				// replace last space with a no bracking space
						    string = string.replace(/ ([^ ]*)$/, spacer + '$1');

						    //console.log( string );
						    
						    // reset the transformed string
						    $s.html(string);

						    // debug
						    $s.addClass( 'widow-transform' );
					   	}
	  				});
				}
			}
		}    	
	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.debounceResize( false );
    	this.reset()
    }

}